// The mark of the game: a square tile with the star of energy cut from it.
// It takes the text color.

import { svg } from '../lib/svg';
import { logoTile, type StarForm } from './energyStar';

export const createLogoMark = (form: StarForm = 'small'): SVGSVGElement => {
  const tile = logoTile(form);
  return svg('svg', { class: 'logo-mark', viewBox: tile.viewBox, 'aria-hidden': 'true' }, [
    svg('path', { d: tile.path, 'fill-rule': 'evenodd' }),
  ]);
};
